import $i18n from 'panda-i18n'; /* eslint-disable require-atomic-updates */
import locale from '@/locale';
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable no-async-promise-executor */
/* eslint-disable @typescript-eslint/no-invalid-void-type */
import React, { Fragment } from 'react';
import { createForm, isForm } from '@formily/core';
import isPlainObject from 'lodash/isPlainObject';
import isFunction from 'lodash/isFunction';
import { toJS } from '@formily/reactive';
import { FormProvider, Observer, observer } from '@formily/react';
import { applyMiddleware, isBool, isFn, isNum, isStr, } from '@formily/shared';
// local component
import { CnDrawer } from '@/components/cn-drawer';
import { CnCard } from '@/components/cn-card';
import { SchemaField } from '@/form/schema-field';
import { createPortalRoot, loading } from '@/form/__builtins__';
import { request } from 'cn-request';
const isModalTitle = (props) => {
    return (isNum(props) || isStr(props) || isBool(props) || React.isValidElement(props));
};
const getModelProps = (props) => {
    if (isModalTitle(props)) {
        return {
            title: props,
        };
    }
    else {
        return props;
    }
};
$i18n.init({
    locale,
    componentName: 'CnQuickDialogForm',
});
export function cnQuickDialogForm(cnDialogProps, renderer, 
/**
 * 点击提交后的请求配置
 */
requestConfig) {
    // 全局环境属性
    const env = {
        host: document.createElement('div'),
        form: null,
        promise: null,
        components: {},
        openMiddlewares: [],
        confirmMiddlewares: [],
        cancelMiddlewares: [],
    };
    const root = createPortalRoot(env.host, 'form-dialog');
    const dialogProps = getModelProps(cnDialogProps);
    const modal = {
        ...dialogProps,
        // 移动端不存在center
        placement: dialogProps.placement === 'center' ? 'right' : dialogProps.placement,
    };
    const DialogContent = observer(() => {
        return (React.createElement(Fragment, null, isFn(renderer) ? (renderer(env.form)) : (React.createElement(SchemaField, { components: env.components, schema: renderer }))));
    });
    // 渲染 Dialog 主题
    const renderDialog = (visible, resolve, reject) => {
        return (React.createElement(Observer, null, () => (React.createElement(CnDrawer, { ...modal, container: env.host, visible: visible, onClose: (trigger, e) => {
                modal?.onClose?.(trigger, e);
                // TODO: 目前Dialog没有afterClose能力，暂时用此办法实现
                setTimeout(() => {
                    dialogProps?.afterClose?.();
                    root.unmount();
                }, 500);
                reject && reject();
            }, onOk: (e) => {
                if (modal?.onOk?.(e) !== false) {
                    resolve && resolve();
                }
            }, footer: true, okProps: {
                visible: true,
                loading: env.form?.submitting,
                children: $i18n.get({
                    id: 'Confirm',
                    dm: '确认',
                    ns: 'CnQuickDialogForm',
                }),
                ...modal.okProps,
            }, cancelProps: {
                visible: true,
                children: $i18n.get({
                    id: 'Cancel',
                    dm: '取消',
                    ns: 'CnQuickDialogForm',
                }),
                ...modal.cancelProps,
            }, onCancel: (e) => {
                if (modal?.onCancel?.(e) !== false) {
                    reject && reject();
                }
            } },
            React.createElement(CnCard, null,
                React.createElement(FormProvider, { form: env.form },
                    React.createElement(DialogContent, null)))))));
    };
    document.body.appendChild(env.host);
    // 数据格式化处理
    function handleData(values) {
        // @ts-ignore
        if (requestConfig?.formatData && isFn(requestConfig?.formatData)) {
            // @ts-ignore
            return requestConfig.formatData(values);
        }
        else {
            return values;
        }
    }
    const formDialog = {
        registerComponents: (components) => {
            env.components = components;
            return formDialog;
        },
        forOpen: (middleware) => {
            if (isFn(middleware)) {
                env.openMiddlewares.push(middleware);
            }
            return formDialog;
        },
        forConfirm: (middleware) => {
            if (isFn(middleware)) {
                env.confirmMiddlewares.push(middleware);
            }
            return formDialog;
        },
        forCancel: (middleware) => {
            if (isFn(middleware)) {
                env.cancelMiddlewares.push(middleware);
            }
            return formDialog;
        },
        open: async (props) => {
            if (env.promise) {
                return env.promise;
            }
            env.promise = new Promise(async (resolve, reject) => {
                try {
                    // forOpen 中间件植入
                    props = await loading('Loading', () => {
                        return applyMiddleware(props, env.openMiddlewares);
                    });
                    if (!env.form) {
                        if (isForm(props)) {
                            env.form = props;
                        }
                        else {
                            env.form = createForm(props);
                        }
                    }
                }
                catch (e) {
                    reject(e);
                }
                root.render(() => {
                    return renderDialog(true, () => {
                        env.form
                            .submit(async () => {
                            // 增加远程接口提交
                            let res;
                            if (isPlainObject(requestConfig)) {
                                res = await request({
                                    ...requestConfig,
                                    data: toJS(handleData(env.form.values)),
                                });
                            }
                            if (isFunction(requestConfig)) {
                                res = await requestConfig(toJS(env.form.values));
                            }
                            // 点击提交的中间件
                            env.form.response = res;
                            await applyMiddleware(env.form, env.confirmMiddlewares);
                            resolve(toJS(env.form.values));
                            formDialog.close();
                        })
                            .catch(() => { });
                    }, async () => {
                        await loading($i18n.get({
                            id: 'Loading',
                            dm: '加载中',
                            ns: 'CnQuickDialogForm',
                        }), () => {
                            return applyMiddleware(env.form, env.cancelMiddlewares);
                        });
                        formDialog.close();
                    });
                });
            });
            return env.promise;
        },
        close: () => {
            if (!env.host)
                return;
            root.render(() => renderDialog(false));
            env.promise = null;
        },
    };
    // @ts-ignore
    return formDialog;
}
